import { h, FunctionComponent } from 'preact';
import { useEffect } from 'preact/hooks';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { trackPageMount } from '~src/utils/tracking';
import { Page } from '../common/enums/api';
import { mcodeSelector } from '../common/state/commonSelectors';
import * as styles from '~src/styles/domains/error/ErrorPage.module.scss';

const ErrorPage: FunctionComponent = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const mcode = useSelector(mcodeSelector);
  const errorMessages = t('common:mcodes', { returnObjects: true });
  const errorMessage = mcode != undefined && errorMessages?.[mcode];

  useEffect(() => {
    dispatch(trackPageMount(Page.ERROR));
  });

  return (
    <div className={styles['error-wrapper']}>
      <h2 className={styles['error-message']}>{errorMessage}</h2>
    </div>
  );
};

export default ErrorPage;
